/** 레거시 `commissionDrugCode.js` 포팅 */

const stripInvisibleChars = (value: unknown): string =>
  String(value ?? '').replace(/[\u00a0\u200b-\u200d\ufeff\u2060]/g, '');

const cleanCommissionDrugCode = (value: unknown): string => {
  if (value == null || value === '') return '';
  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(Math.trunc(value));
  }
  let raw = stripInvisibleChars(value);
  raw = raw.split(/[\r\n\u2028\u2029]+/)[0] ?? '';
  return raw.replace(/[\s]+/g, '');
};

export const extractCommissionDrugCodeDigits = (value: unknown): string => {
  const raw = cleanCommissionDrugCode(value);
  const digitMatch = raw.match(/^\d+/);
  return digitMatch ? digitMatch[0] : '';
};

/**
 * 제품코드를 업로드용 9자리로 맞춘다.
 * 숫자만 있으면 기존처럼 0 패딩하고, 영문이 섞여도 정확히 9자면 그대로 보낸다.
 */
export const normalizeCommissionDrugCodeToNineDigits = (
  value: unknown,
): { ok: boolean; code: string; reason?: 'too_long' } => {
  const raw = cleanCommissionDrugCode(value);
  if (!raw) return { ok: true, code: '' };

  if (/^\d+$/.test(raw)) {
    if (raw.length > 9) return { ok: false, code: raw, reason: 'too_long' };
    return { ok: true, code: raw.padStart(9, '0') };
  }

  if (raw.length === 9) return { ok: true, code: raw };
  if (raw.length > 9) return { ok: false, code: raw, reason: 'too_long' };
  return { ok: true, code: '' };
};

export const normalizeCommissionDrugCode = (value: unknown): string =>
  normalizeCommissionDrugCodeToNineDigits(value).code || '';
